<!-- Zoning codes (table) -->
<div class="zoning-codes-container">
    <mat-form-field class="mat-input-placeholder" subscriptSizing="dynamic">
        <input matInput placeholder="Search (Name/Gridics Id)" (keyup)="doFilter($event.target.value)" type="text" />
    </mat-form-field>
    <button mat-fab class="add-button" (click)="openNewZoningCodeDialog()">
        <mat-icon aria-label="Add Zoning Code">add</mat-icon>
    </button>
    <mat-sidenav-container autosize style="height: calc(100% - 65px);">
        <mat-sidenav class="zoning-code-version-sidenav" #sidenav [opened]="isOpen" mode="side" position="end"
            [style.width.px]="width" [style.min-width.px]="minWidth" [style.max-width.px]="maxWidth">
            <app-zoning-code-version-details *ngIf="isOpen" [sidenav]="sidenav" [detailsData]="detailsData"
                [attachmentType]="attachmentType" [isLoaded]="isLoaded" (isWidthChange)="setWidth($event)"
                [width]="width">
            </app-zoning-code-version-details>
        </mat-sidenav>

        <div class="g-table-wrapper">
            <div class="table-container">
                <table mat-table *ngIf="zoningCodes" [dataSource]="dataSource" multiTemplateDataRows matSort
                    class="mat-elevation-z0">

                    <ng-container matColumnDef="indexColumn">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element; let i = dataIndex;"> {{i + 1}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name
                        </th>
                        <td mat-cell *matCellDef="let zoningCode" (click)="openZCSideNav(zoningCode)">
                            <a [routerLink]="['../../zoning-code', zoningCode.Id]"
                                [queryParams]="{ state_env: instance.State.toLowerCase() }" class="zoning-code-link"
                                (click)="clickZoningCodeName()" title="Click to view details">{{
                                zoningCode.Name }}<mat-icon class="zoning-code-info-icon">info</mat-icon><mat-icon
                                    *ngIf="zoningCode.isOrphan" class="zoning-code-info-icon red-text"
                                    style="margin-left: 0px;"
                                    title="This Zoning Code does not exists in ZoneIQ any more">link_off</mat-icon></a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="{{ cell.property }}" *ngFor="let cell of zoningCodeCells">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{
                            cell.title }}
                        </th>
                        <td mat-cell *matCellDef="let zoningCode" (click)="openZCSideNav(zoningCode)">
                            {{ zoningCode[cell.property] }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="PropertyRecordsCount">
                        <th mat-header-cell *matHeaderCellDef>Property Records Count
                        </th>
                        <td mat-cell *matCellDef="let zoningCode" (click)="openZCSideNav(zoningCode)">
                            <reload-na-value [value]="zoningCode.propertyRecordsCount" [naValue]="-1"
                                [clickHandler]="getZoningCodeStatisticCallback(zoningCode)" [alwaysReload]="true">
                            </reload-na-value>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="Actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let zoningCode" (click)="openZCSideNav(zoningCode)"
                            class="actions-container">
                            <app-zoning-code-check-version-button [zoningCode]="zoningCode">
                            </app-zoning-code-check-version-button>

                            <app-zoning-code-index-button [zoningCode]="zoningCode">
                            </app-zoning-code-index-button>

                            <app-zoning-code-reindex-button [zoningCode]="zoningCode">
                            </app-zoning-code-reindex-button>

                            <app-zoning-code-reindex-with-cursor-button [zoningCode]="zoningCode">
                            </app-zoning-code-reindex-with-cursor-button>

                            <app-zoning-code-check-status-button [openDialog]="true" [isOpen]="isOpen"
                                [zoningCode]="zoningCode" [isLoaded]="isLoaded" (isLoadedChange)="setIsLoaded($event)"
                                (isLoadedDialog)="setIsLoadedZCDialog($event, zoningCode)">
                            </app-zoning-code-check-status-button>

                            <app-zoning-code-delete-button [zoningCode]="zoningCode">
                            </app-zoning-code-delete-button>

                            <app-process-small-spinner class="zc-small-spinner" *ngIf="isLoadedZCDialog"
                                [isVisible]="zoningCode.isWaitingActionFinish">
                            </app-process-small-spinner>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let zoningCode" (click)="openZCSideNav(zoningCode)">
                            <ng-container *ngIf="!zoningCode.isDeleting; else removingInProgress">
                                <app-task-view *ngFor="let task of zoningCode.Tasks" [task]="task"
                                    [showTaskTabButton]="true">
                                </app-task-view>
                            </ng-container>
                            <ng-template #removingInProgress>
                                Removing in progress
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="MissedEntities">
                        <th mat-header-cell *matHeaderCellDef>Missed Entities
                        </th>
                        <td mat-cell *matCellDef="let zoningCode" (click)="missedEntitiesClick($event)">
                            <app-missed-entities-details-icon
                                [missedEntitiesData]="zoningCode?.ZoningCodeRecord?.MetaData">
                            </app-missed-entities-details-icon>
                        </td>
                    </ng-container>

                    <!--Expand-->
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let zoningCode" [attr.colspan]="zoningCodeColumnsToDisplay.length">
                            <div class="example-element-detail"
                                [ngClass]="zoningCode == expandedElement ? 'expanded' : 'collapsed'">

                                <app-zoning-code-versions-list [zoningCode]="zoningCode" style="width: 100%"
                                    [zoningCodeVersionSelectionHandler]="openZCVersionSideNav.bind(this)"
                                    [setIsLoadedZCVersionDialogHandler]="setIsLoadedZCVersionDialog.bind(this)"
                                    [setIsLoadedHandler]="setIsLoaded.bind(this)" [showCalcButton]="true"
                                    [showReCalcButton]="true" [showCheckStatusButton]="true" [showDeleteButton]="true"
                                    [showSetLastUpdateButton]="true" [stateEnv]="instance.State">
                                </app-zoning-code-versions-list>
                            </div>
                        </td>
                    </ng-container>
                    <!--Expand-->

                    <tr mat-header-row *matHeaderRowDef="zoningCodeColumnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let zoningCode; columns: zoningCodeColumnsToDisplay"
                        [class.example-expanded-row]="expandedElement === zoningCode"
                        (click)="showVersions(zoningCode)"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
            </div>
        </div>
    </mat-sidenav-container>
</div>